import { useState } from 'react';
import styles from './answer-form.module.css';
import clsx from 'clsx';

function AnswerForm({ type, onSubmit, shake, setShake, placeholder }: any) {
  const [answer, setAnswer] = useState('')
  return (
    <form className={clsx(styles.form, { [styles.shake]: shake } )}>
      <input 
        type={type} 
        className={styles.input} 
        placeholder={placeholder}
        onChange={event => { setShake(false); setAnswer(event.target.value) }}
      ></input>
      <button type="submit" className={styles.button} onClick={(event) => { event.preventDefault(); onSubmit(answer); }}>
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M5 12h14"/><path d="m12 5 7 7-7 7"/></svg>
      </button>
    </form>
  )
}

export default AnswerForm;
